export enum ApiRoutes {
	UtilsOptions = "/utils/options",

	AdminPermissions = "/administration/permissions",
	AdminCompanies = "/administration/companies",
	AdminRoles = "/administration/roles",
	AdminUsers = "/administration/users",
	AdminUserFilters = "/administration/users/{id}/filters",

	AuthSignIn = "/auth/sign-in",
	AuthSignInSelectWorkspace = "/auth/sign-in/workspace",
	AuthWorkspaces = "/auth/sign-in/workspaces",
	AuthRecoverPasswordInitiate = "/auth/recover/initiate",
	AuthRecoverPasswordComplete = "/auth/recover/complete",

	AuthMe = "/auth/me",
	AuthMePassword = "/auth/me/password",
	FiltersAvailable = "/me/filters/available",
	CustomFilter = "/me/filters/custom",
	SupersetDashboards = "/me/dashboards",

	ServicesGeocodeAddress = "/services/geocode-address",
	ServicesReverseGeocodeLocation = "/services/reverse-geocode-location",

	ConfigurationSearchNodes = "/configuration/search/nodes",

	ResultsScopeEmissions = "/results/search/emissions/by-scope",
	ResultsActivityEmissions = "/results/search/emissions/by-activity",
	ResultsCountryEmission = "/results/search/emissions/by-country",
	ResultsEmissions = "/results/search/emissions",
	ResultsEmissionsIntervals = "/results/search/emissions/intervals",
	ResultsEmissionsSitesSource = "/results/search/sites/emissions/by-source",
	ResultsTransportGreenrouter = "/results/search/transports/trips",
	ResultsEntitiesGreenrouter = "/results/search/transports/entities",
	ResultsTransportEntitiesGreenRouter = "/results/transports/trips/{id}/entities",
	ResultsTripDetails = "/results/transports/trips/{id}",
	ResultsEntityDetails = "/results/transports/entities/{entityId}/trips/{transportId}",
	ResultsTransportEmission = "/results/search/transports/emissions",
	ResultsEmissionType = "/results/search/transports/emissions/haulage",
	ResultsChainTransportEmission = "/results/search/transports/emissions/chain",
	ResultsTripsThirdParty = "/results/search/transports/trips/third-party",
	ResultsTransportThirdPartyDetail = "/results/sites/nodes/third-party/{id}",

	ResultsSitesThirdParty = "/results/search/sites/nodes/third-party",
	ResultsSitesThirdPartyDetail = "results/search/sites/nodes/third-party/{id}",

	ResultsSitesEmissions = "/results/search/sites/emissions",
	ResultsConsumptionIntervals = "/results/search/sites/consumptions/intervals",
	ResultsElectricityConsumption = "/results/search/sites/consumptions/electricity",
	ResultsWaterConsumption = "/results/search/sites/consumptions/water",
	ResultsFuelConsumption = "/results/search/sites/consumptions/fuels",
	ResultsRefrigerantsConsumption = "/results/search/sites/consumptions/refrigerants",
	ResultsHeatSteamConsumption = "/results/search/sites/consumptions/heat-steam",
	ResultsProcessGasConsumption = "/results/search/sites/consumptions/process-gas",
	ResultGreerouterSitesList = "/results/search/sites/nodes",
	ResultGreerouterNodesMap = "/results/search/sites/nodes/map",
	ResultsSitesNodeDetails = "/results/sites/nodes/{id}",
	ResultsSitesNodeDetailsConsumption = "/results/sites/nodes/{id}/consumptions",

	ResultsNodeElectricityConsumption = "/results/sites/nodes/{id}/consumptions/electricity",
	ResultsNodeFuelConsumption = "/results/sites/nodes/{id}/consumptions/fuels",
	ResultsNodeRefrigerantsConsumption = "/results/sites/nodes/{id}/consumptions/refrigerants",
	ResultsNodeProcessGasConsumption = "/results/sites/nodes/{id}/consumptions/process-gas",
	ResultsNodeHeatSteamConsumption = "/results/sites/nodes/{id}/consumptions/heat-steam",
	ResultsNodeWaterConsumption = "/results/sites/nodes/{id}/consumptions/water",

	ResultThirdPartyCalculationMethods = "/results/search/emissions/calculation-methods",
	ResultThirdPartyNodesCertification = "/results/search/emissions/certification",
	ResultThirdPartyEnvironmentalKpi = "/results/search/emissions/environmental-kpi",

	ResultsTranposrtPDFDownload = "/results/report/transports",
	OperationalUnitsPDFDownload = "/results/report/sites",

	CustomMenuFilters = "/me/filters/custom/{id}",
	PinMenuFilter = "/me/filters/favorite/{id}",

	CarbonSnapNodesSearch = "/carbonsnap/nodes/search",
	CarbonSnapGeocode = "/carbonsnap/geocode",
	CarbonSnapCalculate = "/carbonsnap/calculate",

	ConfigurationSitesNodes = "/configuration/sites/nodes",
	ConfigurationSitesNodesUpdate = "/configuration/sites/nodes/{id}",
	ConfigurationDeleteNodes = "/configuration/sites/nodes/bulk-delete",
	ConfigurationGoodFlows = "/configuration/sites/nodes/{id}/goods-flow",
	ConfigurationFilters = "/configuration/sites/nodes/{id}/filters",

	RootCauseWidjetAggregate = "/results/root-cause/widget/aggregate",
	RootCauseWidjetWaterfall = "/results/root-cause/widget/waterfall",
	RootCauseWidjetPerimeter = "/results/root-cause/widget/perimeter",
	RootCauseWidjetTransportQuantity = "/results/root-cause/widget/transport-quantity",
	RootCauseWidjetModalShift = "/results/root-cause/widget/modal-shift",

	RootCauseWidjetEmissionsChangeRoad = "/results/root-cause/widget/emission-factor-changes/road",
	RootCauseWidjetEmissionsChangeTrain = "/results/root-cause/widget/emission-factor-changes/rail",
	RootCauseWidjetEmissionsChangeShip = "/results/root-cause/widget/emission-factor-changes/maritime",
	RootCauseWidjetEmissionsChangeAir = "/results/root-cause/widget/emission-factor-changes/air",
	RootCauseWidjetEmissionsChangeWaterways = "/results/root-cause/widget/emission-factor-changes/barge",
	RootCauseWidjetEmissionsChangeTotal = "/results/root-cause/widget/emission-factor-changes/total",
}
